import type { SearchKind } from '../../api/search';

import { NAV_THEMES, type NavTheme } from './nav-tokens';
import { SEARCH_TARGETS } from './search/search-kinds';

interface PaletteChipsProps {
  kinds: SearchKind[];
  selected: SearchKind | null;
  onSelect: (kind: SearchKind | null) => void;
  theme: NavTheme;
}

/** Narrows the results to one kind; "All" shows a few of each. */
export default function PaletteChips({ kinds, selected, onSelect, theme }: PaletteChipsProps) {
  const t = NAV_THEMES[theme];
  const chips: { kind: SearchKind | null; label: string }[] = [
    { kind: null, label: 'All' },
    ...kinds.map((kind) => ({ kind, label: SEARCH_TARGETS[kind].groupLabel })),
  ];

  return (
    <div
      role="group"
      aria-label="Filter results"
      className="flex flex-wrap items-center"
      style={{ gap: 6, padding: '8px 16px', borderBottom: `1px solid ${t.border}` }}
    >
      {chips.map((chip) => {
        const on = chip.kind === selected;
        return (
          <button
            key={chip.label}
            type="button"
            aria-pressed={on}
            // Keeps focus in the search box, so typing carries on after a click.
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onSelect(chip.kind)}
            style={{
              fontSize: 11.5,
              padding: '3px 10px',
              borderRadius: 999,
              cursor: 'pointer',
              border: `1px solid ${on ? t.moss : t.border}`,
              background: on ? t.cream : 'transparent',
              color: on ? t.barkDark : t.muted,
            }}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
}
